import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import Layout from "../components/layout/layout";

const PrivateRoute = ({ component: Component, auth, ...others }) => {
  return (
    <Route
      {...others}
      render={(props) =>
        auth.isAuthenticated ? (
          <Layout>
            <Component />
          </Layout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

PrivateRoute.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(PrivateRoute);
